import "./PrivacyPolicy.css"; // Import your stylesheet

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import "./App.css";
import "antd/dist/antd.variable.min.css";
import QisasPlusPrivacy from "./pages/QisasPlusPrivacy";
import Home from "./pages/Home";
import { Layout } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import AppFooter from "./components/AppFooter";
import ServicesPage from "./pages/ServicesPage";
import AppHeader from "./components/AppHeader";
import PortfolioPage from "./pages/PortfolioPage";
import CapitalsPrivacy from "./pages/CapitalsPrivacy";
import ElQuizPrivacy from "./pages/ElQuizPrivacy";
import QuranAppPrivacy from "./pages/QuranAppPrivacy";
import QrCodeReaderAppPrivacy from "./pages/QrCodeReaderAppPrivacy";
import MyCycleAppPrivacy from "./pages/MyCycleAppPrivacy";
import HexStackPrivacy from "./pages/HexStackPrivacy";
const { Content } = Layout;

const firebaseConfig = {
  apiKey: "AIzaSyCU2UdYSp7pF9A3MvkcH9ddbVed6oKSOIU",
  authDomain: "dz-enligne-dashboard.firebaseapp.com",
  projectId: "dz-enligne-dashboard",
  storageBucket: "dz-enligne-dashboard.appspot.com",
  messagingSenderId: "841412920205",
  appId: "1:841412920205:web:faf46a5b30ac13d09173c4",
};

ConfigProvider.config({
  theme: {
    //primaryColor: "#009bbb",
    primaryColor: "#000000",
  },
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);

function App() {
  const [visible, setVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 980); // Adjust the breakpoint as needed
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
  return (
    <ConfigProvider
      theme={{
        token: {
          //colorPrimary: "#009bbb",
          colorPrimary: "#000000",
          //fontFamily: "MyFont",
        },
      }}
    >
      <Router>
        <Layout>
          <AppHeader
            isMobile={isMobile}
            showDrawer={showDrawer}
            onClose={onClose}
            visible={visible} // Pass 'visible' prop
          />
          <Content style={{ padding: !isMobile ? "0 50px" : "10px" }}>
            <div className="site-layout-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route
                  path="/services"
                  element={<ServicesPage isMobile={isMobile} />}
                />
                <Route
                  path="/portfolio"
                  element={<PortfolioPage isMobile={isMobile} />}
                />
                <Route
                  path="/QisasPlusPrivacy"
                  element={<QisasPlusPrivacy />}
                />
                <Route path="/CapitalsPrivacy" element={<CapitalsPrivacy />} />
                <Route path="/ElQuizPrivacy" element={<ElQuizPrivacy />} />
                <Route path="/QuranAppPrivacy" element={<QuranAppPrivacy />} />
                <Route
                  path="/QrCodeReaderAppPrivacy"
                  element={<QrCodeReaderAppPrivacy />}
                />
                <Route
                  path="/MyCycleReaderAppPrivacy"
                  element={<MyCycleAppPrivacy />}
                />
                <Route path="/HexStackPrivacy" element={<HexStackPrivacy />} />
              </Routes>
            </div>
          </Content>
          {/*
        <Footer style={{ textAlign: "center" }}>Eljousour Studio ©2024</Footer>
        */}
          <AppFooter />
        </Layout>
      </Router>
    </ConfigProvider>
  );
}

export default App;
